import type { MutationResult } from '@apollo/react-common';
import { useMutation } from '@apollo/react-hooks';
import gqlTagSwag from 'graphql-tag';
import { UNASSIGNED_EPIC_ID } from '../../../common/constants.tsx';
import type { UpdateEpicParent, UpdateEpicParentMutationResponse, Issue } from './types.tsx';

export const UPDATE_EPIC_PARENT_MUTATION = gqlTagSwag`mutation BacklogIssueParentUpdate(
        $boardId: ID!,
        $issueParentId: ID,
        $issueIds: [ID!]!
    ) {
        updateIssueParent(input: {boardId: $boardId, issueParentId: $issueParentId, issueIds: $issueIds }) {
            success
        }
    }`;

export const useUpdateEpicParentMutation = (
	boardId: number,
): [UpdateEpicParent, MutationResult<UpdateEpicParentMutationResponse>] => {
	const [mutate, epicParentUpdateMutationData] = useMutation(UPDATE_EPIC_PARENT_MUTATION);
	const updateParent: UpdateEpicParent = (issues: Issue[], issueParentId: number) =>
		mutate({
			variables: {
				boardId,
				issueParentId: issueParentId === UNASSIGNED_EPIC_ID ? null : issueParentId,
				issueIds: issues.map(({ id }: Issue) => id),
			},
		});

	return [updateParent, epicParentUpdateMutationData];
};
